

export const ALLOWED_CHARACTERS_REGEX: RegExp = /(^[a-zA-Z0-9][_a-zA-Z0-9-.]+(\.[_a-zA-Z0-9-]+)*$)|(^[a-zA-Z0-9_]+([\w-\.]*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$)/;
export const ALLOWED_PASSWORD_CHARACTERS_REGEX: RegExp = /^((?!^(\d+|[a-zA-Z]+)$)^[a-zA-Z0-9]{8,12})$/;
export const VALID_EMAIL_REGEX: RegExp = /^[a-zA-Z0-9_+]+([\w-\.]*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

/*
Email: /^[a-zA-Z0-9_+]+([\w-\.]*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
*/
